export default "__VITE_ASSET__hnXYQ2nt__"